import angular from 'angular';

import notificationModule from '../ui/notification/notification.module';

import './dashboard.export.scss';

export default angular.module('dashboard.export', [notificationModule.name]);
